import { createApp } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import CampaignDashboard from '../pages/CampaignDashboard.vue';
import CampaignDashboardChart from '../components/CampaignDashboardChart.vue';
import DateRangePicker from '../components/DateRangePicker.vue';

class CampaignDashboardComponent {
  constructor({ container, campaignId }) {
    this.app = null;
    this.container = container;
    this.campaignId = campaignId;
  }

  init() {
    this.app = createApp(CampaignDashboard, {
      campaignId: this.campaignId
    });

    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6
    });

    this.app.component('CampaignDashboardChart', CampaignDashboardChart);
    this.app.component('DateRangePicker', DateRangePicker);

    this.app.mount(this.container);
  }
}

export default CampaignDashboardComponent;
